export default "__VITE_ASSET__BhzMVR3b__"